"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTableHeader = exports.renderProductDetailsColumn = exports.renderProductDetails = exports.renderProductAttribute = exports.renderIntro = exports.formatComparisonColumnGroups = exports.checkMatchingProductDetail = exports.ComparisonToolTip = void 0;
var _greenTick = _interopRequireDefault(require("../../images/green-tick.svg"));
var _blueTick = _interopRequireDefault(require("../../images/blue-tick.svg"));
var _tooltipIcon = _interopRequireDefault(require("../../images/tooltip-icon.svg"));
var _tooltipCloseIcon = _interopRequireDefault(require("../../images/tooltip-close-icon.svg"));
var _react = _interopRequireWildcard(require("react"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _EcommerceCard = _interopRequireDefault(require("../EcommerceCard/EcommerceCard"));
var _CTAWithHeader = _interopRequireDefault(require("../CTAWithHeader/CTAWithHeader"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderIntro = (headline, subHeading, eyebrow, description, tableVariant, productDetails, Link) => {
  if (eyebrow || headline || subHeading || description) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("caption", {
      className: "ter-comparison-table__caption"
    }, /*#__PURE__*/_react.default.createElement(_CTAWithHeader.default, {
      eyebrow: eyebrow && eyebrow,
      headline: headline && headline,
      subhead: subHeading && subHeading,
      content: description && description
    })), tableVariant === "horizontal" && /*#__PURE__*/_react.default.createElement("thead", {
      className: "ter-comparison-table__divider-wrapper"
    }, productDetails?.length > 0 && /*#__PURE__*/_react.default.createElement("tr", {
      className: "ter-comparison-table__divider-wrapper ter-comparison-table__skip"
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      Link: Link && Link,
      to: "#skip-link",
      tabIndex: "0"
    }, "Skip comparison of ", productDetails?.length, " items")))));
  }
  return;
};

// reformat the comparisonColumnGroups to a single array of all comparisonColumns items
exports.renderIntro = renderIntro;
const formatComparisonColumnGroups = comparisonColumnGroups => {
  return [].concat.apply([], comparisonColumnGroups?.map(group => group.comparisonColumns));
};
exports.formatComparisonColumnGroups = formatComparisonColumnGroups;
const renderTableHeader = (tableVariant, tableHeaders, columnGroups, scrollPosition, headerVariant) => {
  if (tableVariant === "horizontal") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", {
      className: "ter-comparison-table__row ter-comparison-table__group-title"
    }, /*#__PURE__*/_react.default.createElement("th", {
      className: "ter-comparison-table__blank",
      colSpan: "0"
    }, /*#__PURE__*/_react.default.createElement("span", null)), columnGroups?.map((group, index) => {
      return /*#__PURE__*/_react.default.createElement("th", {
        key: `column-` + index,
        colSpan: group?.comparisonColumns?.length,
        scope: "colgroup",
        "data-sb-object-id": group?.contentfulId ? group?.contentfulId : null
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__comparison-cell",
        "data-sb-field-path": "categoryName"
      }, group?.categoryName));
    })), /*#__PURE__*/_react.default.createElement("tr", {
      className: "ter-comparison-table__row ter-comparison-table__row--header"
    }, /*#__PURE__*/_react.default.createElement("th", {
      className: "ter-comparison-table__blank",
      colSpan: "0"
    }, /*#__PURE__*/_react.default.createElement("span", null)), columnGroups?.map((group, i) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: i
      }, RenderComparisonColumns(group, tableVariant));
    })));
  } else if (tableVariant === "vertical") {
    return /*#__PURE__*/_react.default.createElement("tr", {
      className: `ter-comparison-table__row--vertical ter-comparison-table__row--vertical--${tableHeaders?.length}-column`
    }, /*#__PURE__*/_react.default.createElement("th", {
      colSpan: "0",
      "aria-label": "Features"
    }, /*#__PURE__*/_react.default.createElement("span", null)), headerVariant?.includes("basic header cards") ? tableHeaders?.slice(0, 4)?.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement("th", {
        key: `column-` + index,
        colSpan: item?.length,
        scope: "colgroup",
        className: "ter-comparison-table__row--vertical__basic-headers",
        "data-sb-object-id": item?.contentfulId ? item?.contentfulId : null
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__row--vertical__basic-headers--heading",
        "data-sb-field-path": "headerText"
      }, item?.headerText), /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__row--vertical__basic-headers--description",
        "data-sb-field-path": "textDescription"
      }, item?.textDescription));
    }) : tableHeaders?.slice(0, 4)?.map((product, index) => {
      const cardContent = {
        eyebrow: product?.eyebrow,
        header: product?.header,
        image: product?.image,
        cardLink: product?.cardLink,
        bgColor: !product?.image ? "grey" : "",
        text: product?.text,
        Link: product?.Link,
        cardLabel: product?.cardLabel,
        productPrice: product?.productPrice,
        productPageLink: product?.productPageLink,
        trialLink: product?.trialLink
      };
      return /*#__PURE__*/_react.default.createElement("th", {
        key: `column-` + index,
        colSpan: product?.comparisonColumns?.length,
        scope: "colgroup"
      }, /*#__PURE__*/_react.default.createElement(_EcommerceCard.default, {
        content: cardContent,
        contentfulId: product?.contentfulId
      }));
    }));
  }
};
exports.renderTableHeader = renderTableHeader;
const RenderComparisonColumns = (group, variant, headerVariant) => {
  if (variant === "horizontal") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, group?.comparisonColumns && group?.comparisonColumns?.map((column, index) => {
      return /*#__PURE__*/_react.default.createElement("th", {
        scope: "col",
        key: `column-` + index,
        colSpan: "1",
        className: `ter-comparison-table__heading`,
        "data-sb-object-id": column?.contentfulId ? column?.contentfulId : null
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: `ter-comparison-table__comparison-cell ${column?.columnWidth === "long" ? "ter-comparison-table__comparison-cell--wide" : column?.columnWidth === "medium" ? "ter-comparison-table__comparison-cell--medium" : ""}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-sb-field-path": "columnName"
      }, column?.columnName), column?.tooltipText && /*#__PURE__*/_react.default.createElement(ComparisonToolTip, {
        column: column,
        variant: variant
      })));
    }));
  } else if (variant === "vertical") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, group && group?.map((column, index) => {
      return /*#__PURE__*/_react.default.createElement("span", {
        scope: "col",
        key: `column-` + index,
        colSpan: "1",
        className: `ter-comparison-table__heading ${variant === "vertical" ? "ter-comparison-table__heading--vertical" : ""}`,
        "data-sb-object-id": column?.contentfulId ? column?.contentfulId : null
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: `ter-comparison-table__comparison-cell ${variant === "vertical" ? "ter-comparison-table__comparison-cell--vertical" : ""}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-sb-field-path": "columnName"
      }, column?.columnName), column?.tooltipText && /*#__PURE__*/_react.default.createElement(ComparisonToolTip, {
        column: column,
        variant: variant
      })));
    }));
  }
};
const ComparisonToolTip = _ref => {
  let {
    column,
    variant
  } = _ref;
  const [tooltipOpen, setTooltipOpen] = (0, _react.useState)(false);
  const tooltipIcon = (0, _react.useRef)(null);
  const tooltipPlacement = tooltipIcon?.current ? {
    left: tooltipIcon?.current?.offsetLeft - 18
  } : {};
  (0, _react.useEffect)(() => {
    const escPressHandler = e => {
      if (e.code === "Escape" && tooltipOpen === true) {
        setTooltipOpen(false);
      }
    };
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      document?.addEventListener("keydown", escPressHandler);
    }
    return () => {
      if (typeof window !== "undefined" && typeof document !== "undefined") {
        document?.removeEventListener("keydown", escPressHandler);
      }
    };
  }, [tooltipOpen]);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: `ter-comparison-table__tooltip ${variant === "vertical" ? "ter-comparison-table__tooltip--vertical" : ""}`
  }, /*#__PURE__*/_react.default.createElement("img", {
    ref: tooltipIcon,
    src: _tooltipIcon.default,
    alt: "tooltip icon",
    className: "ter-comparison-table__tooltip-icon",
    onClick: () => {
      setTooltipOpen(true);
    },
    "aria-label": `More info on ${column?.columnName}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-comparison-table__tooltip-text ${tooltipOpen === true ? "ter-comparison-table__tooltip--open" : ""}`,
    style: tooltipPlacement,
    role: "tooltip"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__tooltip-inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-field-path": "columnTooltipDescription"
  }, column.tooltipRichText ? column.tooltipRichText : column.tooltipText), /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-comparison-table__tooltip-close",
    onClick: () => {
      setTooltipOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _tooltipCloseIcon.default,
    alt: "close tooltip"
  })))));
};
exports.ComparisonToolTip = ComparisonToolTip;
const renderProductNameLink = (product, tableVariant) => {
  if (product?.productLink?.url) {
    return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: product?.productLink?.url && product?.productLink?.url,
      className: `ter-comparison-table__product-title ter-comparison-table__product-title--link ${tableVariant === "vertical" ? "ter-comparison-table__product-title--link--vertical" : ""}`
    }, product?.productName);
  } else {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__product-title"
    }, product?.productName);
  }
};
const renderProductDetailsColumn = function (productDetails, showImages, comparisonColumnGroups) {
  let Link = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let tableVariant = arguments.length > 4 ? arguments[4] : undefined;
  let headerVariant = arguments.length > 5 ? arguments[5] : undefined;
  let locale = arguments.length > 6 ? arguments[6] : undefined;
  if (tableVariant === "horizontal") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, productDetails && productDetails?.map((product, index) => {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: `product-` + index,
        className: "ter-comparison-table__product"
      }, /*#__PURE__*/_react.default.createElement("th", {
        colSpan: "1",
        scope: "row",
        className: "ter-comparison-table__product-column"
      }, displayHiddenColumn(product, showImages), /*#__PURE__*/_react.default.createElement("span", {
        className: `ter-comparison-table__comparison-cell ter-comparison-table__product-info ${product?.productTag ? "ter-comparison-table__product-info--with-tag" : ""}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__product-info-wrapper"
      }, product?.productTag && /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__product-tag"
      }, product?.productTag), showImages === true && product?.image?.url && /*#__PURE__*/_react.default.createElement("img", {
        src: product?.image?.url + "?w=120",
        alt: product?.productName ? product?.productName + " image" : ""
      }), product && renderProductNameLink(product), product?.subHeading && /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__product-subheading"
      }, product?.subHeading), product?.bodyText && /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__product-text"
      }, product?.bodyText)))), renderProductDetails(product?.productAttributes, comparisonColumnGroups, tableVariant, locale));
    }));
  } else if (tableVariant === "vertical") {
    const formattedComparisonColumnGroups = formatComparisonColumnGroups(comparisonColumnGroups);
    return /*#__PURE__*/_react.default.createElement("tr", {
      className: "ter-comparison-table__product-wrapper--vertical"
    }, /*#__PURE__*/_react.default.createElement("th", {
      className: "ter-comparison-table__product-feature-wrapper"
    }, formattedComparisonColumnGroups && formattedComparisonColumnGroups?.length > 0 && RenderComparisonColumns(formattedComparisonColumnGroups, tableVariant, headerVariant)), /*#__PURE__*/_react.default.createElement("th", {
      className: `ter-comparison-table__product--vertical--wrapper ter-comparison-table__product--vertical--wrapper--${productDetails?.length}-column`
    }, productDetails && productDetails?.slice(0, 4)?.map((product, index) => {
      return /*#__PURE__*/_react.default.createElement("span", {
        key: `product-` + index,
        className: "ter-comparison-table__product ter-comparison-table__product--vertical",
        "data-sb-object-id": product?.contentfulId ? product?.contentfulId : null
      }, renderProductDetails(product?.productAttributes, comparisonColumnGroups, tableVariant, headerVariant));
    })));
  }
};
exports.renderProductDetailsColumn = renderProductDetailsColumn;
const displayHiddenColumn = (product, showImages, tableVariant) => {
  // this function returns a copy of the data to the table, purely for sizing the <th> element wrapping it.
  // Without this, the height of the TR isn't calculated properly - the displayed <th> content is position: sticky.
  return /*#__PURE__*/_react.default.createElement("span", {
    className: `ter-comparison-table__comparison-cell ${tableVariant === "vertical" ? "ter-comparison-table__comparison-cell--vertical" : ""} ter-comparison-table__product-info-hidden ${product?.productTag ? "ter-comparison-table__product-info--with-tag" : ""}`
  }, product?.productTag && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-comparison-table__product-tag"
  }, product?.productTag), showImages === true && product?.image?.url && /*#__PURE__*/_react.default.createElement("img", {
    src: product?.image?.url + "?w=120",
    alt: product?.productName ? product?.productName + " image" : ""
  }), /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: product?.productLink?.url && product?.productLink?.url,
    className: "ter-comparison-table__product-title"
  }, product?.productName), product?.subHeading && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-comparison-table__product-subheading"
  }, product?.subHeading), product?.bodyText && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-comparison-table__product-text"
  }, product?.bodyText));
};
const checkMatchingProductDetail = (productAttribute, index, comparisonColumnGroups) => {
  const allColumns = [];
  if (comparisonColumnGroups && comparisonColumnGroups?.length) {
    comparisonColumnGroups?.forEach(column => {
      if (column && column?.comparisonColumns) {
        allColumns.push(...column?.comparisonColumns);
      }
    });
  }
  if (productAttribute?.name && allColumns && allColumns?.length) {
    return productAttribute?.name === allColumns[index]?.columnName ? true : false;
  } else {
    return false;
  }
};
exports.checkMatchingProductDetail = checkMatchingProductDetail;
const renderProductDetails = (productAttributes, comparisonColumnGroups, tableVariant, headerVariant, locale) => {
  if (tableVariant === "horizontal") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, productAttributes && productAttributes?.map((attr, index) => {
      let renderAttribute = checkMatchingProductDetail(attr, index, comparisonColumnGroups) === true ? renderProductAttribute(attr?.value, tableVariant) : locale !== "en" ? renderProductAttribute(attr?.value, tableVariant) : null;
      return /*#__PURE__*/_react.default.createElement("td", {
        colSpan: "1",
        key: `product-attribute-${index}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__comparison-cell",
        "data-sb-object-id": attr?.contentfulId ? attr?.contentfulId : null
      }, renderAttribute));
    }));
  } else if (tableVariant === "vertical") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, productAttributes && productAttributes?.map((attr, index) => {
      let renderAttribute = checkMatchingProductDetail(attr, index, comparisonColumnGroups) === true ? renderProductAttribute(attr?.value, tableVariant) : locale !== "en" ? renderProductAttribute(attr?.value, tableVariant) : null;
      return /*#__PURE__*/_react.default.createElement("span", {
        colSpan: "1",
        key: `product-attribute-${index}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-comparison-table__comparison-cell ter-comparison-table__comparison-cell--vertical",
        "data-sb-object-id": attr?.contentfulId ? attr?.contentfulId : null
      }, renderAttribute));
    }));
  }
};
exports.renderProductDetails = renderProductDetails;
const renderProductAttribute = (value, tableVariant) => {
  let attribute = /*#__PURE__*/_react.default.createElement("span", {
    "data-sb-field-path": "value"
  }, "\u2014");
  if (value && value === true) {
    attribute = /*#__PURE__*/_react.default.createElement("img", {
      src: tableVariant === "horizontal" ? _greenTick.default : _blueTick.default,
      className: "ter-comparison-table__check",
      alt: "Tick Icon",
      "aria-label": "yes",
      "data-sb-field-path": "valueBoolean"
    });
  } else if (value) {
    attribute = /*#__PURE__*/_react.default.createElement("span", {
      "data-sb-field-path": "value"
    }, value);
  }
  return attribute;
};
exports.renderProductAttribute = renderProductAttribute;